import { useEffect, useState } from "react";
import { BigLogo } from "../../assets/icons";
import LayoutWrapper from "../../layouts/landing-page-layout-wrapper/layoutWrapper";
import styles from "./terms.module.scss";
import TabComponent from "./tab";
import { TermsConsumerContent } from "./TermsConsumerContent";
const Terms = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const [activeTab, setActiveTab] = useState("Consumer");

	const handleTabChange = (tab: string) => {
		setActiveTab(tab);
	};
	return (
		<div className={styles.container}>
			<div className={styles.header}>
				<BigLogo height={300} className={styles.image} />
				<LayoutWrapper>
					<div className={styles.headerTextWrapper}>
						<h2 className={styles.headerText}>Terms of service</h2>
						<p className={styles.subHeader}>LAST UPDATED IN MARCH, 2022</p>
					</div>
				</LayoutWrapper>
			</div>
			<LayoutWrapper>
				<div className={styles.tabWrapper}>
					<TabComponent activeTab={activeTab} onTabChange={handleTabChange} />
				</div>
				{activeTab === "Consumer" && (
					<div className={styles.termsBody}>
						<TermsConsumerContent />
					</div>
				)}
			</LayoutWrapper>
		</div>
	);
};
export default Terms;
